import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import  { WarehouseFloorManipulationView } from "./warehouseFloorManipulation-view"

export class WarehouseFloorManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت طبقه انبار ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.warehouseFloor = ObservableArray.create<warehouseFloor>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseFloorManipulationView();
    }
    public getTypeId(): string {
        return "VM-528FEAE0-D923-41CA-8B4A-5CDAFB48CD1F"
    }

    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehouseFloor(v: ObservableArray<warehouseFloor>) { this._warehouseFloor = v; } public get warehouseFloor(): ObservableArray<warehouseFloor> { return this._warehouseFloor;} private _warehouseFloor: ObservableArray<warehouseFloor>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseFloors',{
                FilteringInformation:filteringInformation,
            });
            let rowNumber = 1;
            this.warehouseFloor.update(...result.WarehouseFloors.map(q=>{
                let r = new warehouseFloor(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.name = q.Name;   
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestWarehouseFloorCreation(){
        let editor = new warehouseFloorEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async warehouseFloorUpdater(warehouseFloor:warehouseFloor){
        let editor = new warehouseFloorEditor(this,new UpdateServerUpdater());
        warehouseFloor.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
}

export class warehouseFloor extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseFloorManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
    
    private _typedParent:WarehouseFloorManipulationViewModel;

    cloneTo(warehouseFloor:warehouseFloor){
        warehouseFloor.id = this.id;
        warehouseFloor.name = this.name;
    }

    async edit(){
        this._typedParent.warehouseFloorUpdater(this);
    }  

}

interface IServerUpdater{
    execute(warehouseFloor:warehouseFloor):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return ' طبقه با موفقیت ثبت شد.';
    }
    async execute(warehouseFloor: warehouseFloor): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateNewWarehouseFloor',{
            Name:warehouseFloor.name
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'طبقه با موفقیت به روز رسانی شد.';
    }
    async execute(warehouseFloor: warehouseFloor): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateWarehouseFloor',{
            WarehouseFloorId:warehouseFloor.id,
            Name:warehouseFloor.name
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class warehouseFloorEditor extends warehouseFloor implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:WarehouseFloorManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
    }
    closePopup(resultCode: string = null) {
    }
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push(' نام طبقه مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت طبقه');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}

export class warehouseFloorSelectorViewModel extends SelectorBaseViewModel<warehouseFloorForSelector>{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    
    protected async loadData(): Promise<warehouseFloorForSelector[]> {

        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseFloors',{
        });    
        return result.WarehouseFloors.map(q=>{
            let r = new warehouseFloorForSelector(this);
            r.id=q.Id;
            r.title = q.Name;
            return r;
        }); 
    }
    
}

class warehouseFloorForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}